//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

// demos
import DemoSelectBasic from './demos/DemoSelectBasic.vue'
import DemoSelectDense from './demos/DemoSelectDense.vue'
import DemoSelectVariant from './demos/DemoSelectVariant.vue'
import DemoSelectCustomTextAndValue from './demos/DemoSelectCustomTextAndValue.vue'
import DemoSelectIcons from './demos/DemoSelectIcons.vue'
import DemoSelectChips from './demos/DemoSelectChips.vue'
import DemoSelectMenuProps from './demos/DemoSelectMenuProps.vue'
import DemoSelectMultiple from './demos/DemoSelectMultiple.vue'
import DemoSelectAppendAndPrependItem from './demos/DemoSelectAppendAndPrependItem.vue'
import DemoSelectSelectionSlot from './demos/DemoSelectSelectionSlot.vue'

// code
import {
  selectBasic,
  selectDense,
  selectVariant,
  selectCustomTextAndValue,
  selectIcons,
  selectChips,
  selectMenuProps,
  selectMultiple,
  selectAppendAndPrependItem,
  selectSelectionSlot,
} from './demos/code'

export default {
  components: {
    AppCardCode,
    DemoSelectBasic,
    DemoSelectDense,
    DemoSelectVariant,
    DemoSelectCustomTextAndValue,
    DemoSelectIcons,
    DemoSelectChips,
    DemoSelectMenuProps,
    DemoSelectMultiple,
    DemoSelectAppendAndPrependItem,
    DemoSelectSelectionSlot,
  },
  setup() {
    return {
      codeSnippets: {
        selectBasic,
        selectDense,
        selectVariant,
        selectCustomTextAndValue,
        selectIcons,
        selectChips,
        selectMenuProps,
        selectMultiple,
        selectAppendAndPrependItem,
        selectSelectionSlot,
      },
    }
  },
}
